<template>
  <a-spin :spinning="loading">
    <a-checkbox-group
      v-if="list?.length"
      :value="field.value"
      button-style="solid"
      :options="list"
      @change="onChange"
    />
    <span v-else class="gray9 fs12">{{
      config.placeholder || '暂无数据'
    }}</span>
  </a-spin>
</template>
<script>
import { defineComponent, toRef, ref } from 'vue'
import { props } from './helper'
import useRemote from './useRemote'

export default defineComponent({
  props,
  setup (props) {
    const config = toRef(props, 'config')

    const { loading } = useRemote(props, res => {
      const { attrs = {}} = config.value.remoteApi
      const remoteList = (res.data.List || res.data.list || []).map(i => {
        return { value: '' + i[attrs.valueField], label: i[attrs.labelField] }
      })
      list.value = config.value.list
        ? [...config.value.list, ...remoteList]
        : remoteList
    })

    const onChange = e => {
      props.handleChange(e)
    }

    const list = ref(config.value.list)

    return {
      list,
      loading,
      onChange
    }
  }
})
</script>
<style lang="less" scoped>
.ant-radio-button-wrapper {
  margin: 0 0 8px;
}
</style>
